import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/Icon";
import { refreshTokensApi } from "@/api/refreshTokensApi";

interface ActiveSessionsBlockProps {
  onOpenDevices: () => void;
}

export const ActiveSessionsBlock = ({ onOpenDevices }: ActiveSessionsBlockProps) => {
  const [sessionsCount, setSessionsCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const tokens = await refreshTokensApi.getAll();
        setSessionsCount(tokens.length);
      } catch (error) {
        console.error("Failed to fetch active sessions:", error);
        // Don't show error toast for this background operation
      } finally {
        setIsLoading(false);
      }
    };

    fetchSessions();
  }, []);

  return (
    <div
      className="
        flex flex-col gap-2
        rounded-mds border border-neutral-200/7 bg-neutral-200/2
        p-2
        sm:flex-row sm:items-center sm:justify-between sm:gap-4
      "
    >
      <div className="flex items-center gap-3 pl-2">
        <span className="fs-500 font-bold text-neutral-100">
          {isLoading ? (
            <Icon name="spinner" className="size-4 animate-spin text-neutral-500" />
          ) : (
            sessionsCount
          )}
        </span>
        <span className="fs-300 font-semibold text-neutral-200/50">
          Активных сессии
        </span>
      </div>

      <Button
        variant="neutral"
        size="sm"
        onClick={onOpenDevices}
        disabled={isLoading}
        className="w-full justify-center sm:w-fit"
      >
        Мои устройства
      </Button>
    </div>
  );
};